<template>
  <main>
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">Pencarian Produk Web Service Puskurbuk</h5>
      </div>
      <div class="card-body">
        <div id="collapseFilter">
          <div class="row">
            <div class="col-lg mb-4">
              <label for="" class="">Limit</label>
              <select
                class="form-control"
                name="limitFilter"
                id="limitFilter"
                v-model="limitFilter"
              >
                <option selected disabled>Show</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>

            <div class="col-lg mb-4">
              <label for="" class="">Jenis</label>
              <select
                name=""
                class="form-control"
                id="forPenerbitVal"
                v-model="typeBook"
              >
                <option value="text">Buku Teks Pelajaran</option>
                <option value="nontext">Buku Non Teks Pelajaran</option>
              </select>
              <!-- <vue-select
                class="ml-3"
                :options="jenisKategori"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Pilih Jenis Kategori Buku"
                :clearable="clearable"
              /> -->
            </div>

            <!-- <div class="col-lg mb-4">
              <select
                class="form-control"
                name="listPusbukPenerbit"
                id="listPusbukPenerbit"
                v-model="listPusbukPenerbit"
              >
                <option :value="lpp.value" v-for="(lpp, index) in listPusbukPenerbitData" :key="index">
                  {{ lpp.name }}
                </option>
              </select> -->

            <!-- <vue-select
                class="ml-3"
                :options="penerbit"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Pilih Penerbit"
                :clearable="clearable"
              /> -->
            <!-- </div> -->

            <div class="col-lg mb-4">
              <label for="" class="">Jenjang</label>
              <select
                class="form-control"
                name="levelClass"
                id="levelClass"
                v-model="levelClass"
              >
                <option selected disabled value="">Pilih Jenjang</option>
                <option
                  :disabled="lcd.isDisabled"
                  :value="lcd.id"
                  v-for="(lcd, index) in nonTextLevelClassData"
                  :key="index"
                >
                  {{ lcd.name }}
                </option>
              </select>
            </div>

            <!-- {{classModel === '' ? 'kosong' : classModel }} -->

            <div class="col-lg mb-4">
              <label for="" class="">Kelas</label>
              <select
                name="forClass"
                class="form-control"
                v-model="classModel"
                id="forClass"
              >
                <option value="">Pilih Kelas</option>

                <template v-for="ntcd in nonTextClassData">
                  <template
                    v-if="levelClass === '41a81c2a-166f-400d-b9a1-f6cf0c973e1f'"
                  >
                    <option
                      :selected="isSelected"
                      v-for="(nt, index) in ntcd.Sd"
                      :key="index"
                      :value="nt.id"
                    >
                      Kelas {{ nt.name }}
                    </option>
                  </template>

                  <template
                    v-if="levelClass === '6bdd711e-9a16-4449-bacf-a08f1879b36b'"
                  >
                    <option
                      :selected="isSelected"
                      v-for="(nt, index) in ntcd.Smp"
                      :key="index"
                      :value="nt.id"
                    >
                      Kelas {{ nt.name }}
                    </option>
                  </template>

                  <template
                    v-if="levelClass === 'b5092d4e-c5a5-4f3d-89ac-70661366eac7'"
                  >
                    <option
                      :selected="isSelected"
                      v-for="(nt, index) in ntcd.Sma"
                      :key="index"
                      :value="nt.id"
                    >
                      Kelas {{ nt.name }}
                    </option>
                  </template>
                </template>
              </select>
              <!-- <vue-select
                class="ml-3"
                :options="jenisKategori"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Pilih Jenis Kategori Buku"
                :clearable="clearable"
              /> -->
            </div>

            <div class="col-lg mb-4">
              <label for="" class="">Nama Buku</label>
              <input type="text" class="form-control" v-model="seacrh" />
              <!-- <select name="" class="form-control" id="">
                <option
                  :value="jn.value"
                  v-for="(jn, index) in jenjang"
                  :key="index"
                >
                  {{ jn.text }}
                </option>
              </select> -->
              <!-- <vue-select
                class="ml-3"
                :options="jenjang"
                :reduce="(name) => name.value"
                label="name"
                placeholder="Pilih Jenjang Sekolah"
                :clearable="clearable"
              /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <template v-if="typeBook == 'text'">
          <div class="table-responsive">
            <!-- <div class="col-lg-2 float-right mb-3">
              <input
                class="input-filter"
                id="nameFilter"
                name="nameFilter"
                type="text"
                placeholder="Search..."
              />
              <div class="input-filter-icon">
                <i class="fa fa-search mr-2"></i
                ><span style="font-size: 12px"></span>
              </div>
            </div> -->
            <table
              id="table_order"
              class="
                table table-condensed
                text-center
                table-hover table-loading
              "
              width="100%"
            >
              <thead class="">
                <tr
                  class="
                    table-condensed
                    text-uppercase text-muted text-sm-center
                  "
                >
                  <th
                    id="filterSort"
                    class="filterSort"
                    v-for="col in column"
                    @click="col.value == '' ? sort('') : sort(col.value)"
                    :key="col.name"
                    style="cursor: pointer"
                  >
                    {{ col.name }}
                    <template v-if="col.isOrder">
                      <template v-if="col.order === ''">
                        <i class="up-icon" />
                        <i class="down-icon" />
                      </template>
                      <template v-else>
                        <i
                          :class="[
                            col.order === 'asc' ? 'up-icon' : 'down-icon',
                          ]"
                        />
                      </template>
                    </template>
                    <!-- <i v-if="col.isOrder" style="font-size:9px"
                        :class="[col.order === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down']"/> -->
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listPusbuk == ''">
                  <td class="table-secondary" :colspan="column.length">
                    No Data Found
                  </td>
                </tr>
                <tr v-for="(lp, index) in listPusbuk" :key="index">
                  <td>
                    {{
                      index +
                        pusbukPagination.per_page *
                          pusbukPagination.current_page -
                        pusbukPagination.per_page +
                        1
                    }}
                  </td>
                  <td class="text-wrap">{{ lp.title }}</td>
                  <td>{{ lp.publisher.name }}</td>
                  <td>{{ lp.subjects.school_class.school_level.name }}</td>
                  <td>{{ lp.subjects.school_class.class }}</td>
                  <template v-for="(bp, index) in lp.book_prices">
                    <td :key="index">{{ bp.price }}</td>
                  </template>
                  <td>
                    <button
                      class="btn btn-success"
                      @click="
                        addAsForm(
                          lp.title,
                          lp.cover_image,
                          lp.publisher.name,
                          lp.subjects.school_class.school_level.name,
                          lp.subjects.school_class.class,
                          lp.book_prices[0].price,
                          lp.book_prices[1].price,
                          lp.book_prices[2].price,
                          lp.book_prices[3].price,
                          lp.book_prices[4].price,
                          lp.author,
                          lp.descriptions,
                          lp.id,
                          lp.publisher.id
                        )
                      "
                    >
                      <i class="fa fa-plus-square" aria-hidden="true"></i>
                      Detail
                    </button>
                  </td>
                  <!-- <td><button class="btn btn-warning" @click="getVal(kl.name,kl.penerbit,kl.jenjang,kl.kelas)">getval</button></td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col">
              <p class="text-muted mt-1 ml-4 pull-left">
                Showing
                {{
                  pusbukPagination.per_page * pusbukPagination.current_page -
                    pusbukPagination.per_page +
                    1
                }}
                to
                {{ pusbukPagination.per_page * pusbukPagination.current_page }}
                of {{ pusbukPagination.total }} entries
              </p>
            </div>
            <div class="col">
              <pagination
                :data="pusbukPagination"
                :showDisabled="showDisabled"
                @pagination-change-page="getListPusbuk"
                :align="align"
                :limit="limit"
              ></pagination>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="table-responsive">
            <table
              id="table_order"
              class="
                table table-condensed
                text-center
                table-hover table-loading
              "
              width="100%"
            >
              <thead class="">
                <tr
                  class="
                    table-condensed
                    text-uppercase text-muted text-sm-center
                  "
                >
                  <th
                    id="filterSort"
                    class="filterSort"
                    v-for="col in column"
                    @click="col.value == '' ? sort('') : sort(col.value)"
                    :key="col.name"
                    style="cursor: pointer"
                  >
                    {{ col.name }}
                    <template v-if="col.isOrder">
                      <template v-if="col.order === ''">
                        <i class="up-icon" />
                        <i class="down-icon" />
                      </template>
                      <template v-else>
                        <i
                          :class="[
                            col.order === 'asc' ? 'up-icon' : 'down-icon',
                          ]"
                        />
                      </template>
                    </template>
                    <!-- <i v-if="col.isOrder" style="font-size:9px"
                        :class="[col.order === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down']"/> -->
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listPusbukNonText == ''">
                  <td class="table-secondary" :colspan="column.length">
                    No Data Found
                  </td>
                </tr>
                <tr v-for="(lp, index) in listPusbukNonText" :key="index">
                  <td>
                    {{
                      index +
                        pusbukPaginationNonText.per_page *
                          pusbukPaginationNonText.current_page -
                        pusbukPaginationNonText.per_page +
                        1
                    }}
                  </td>
                  <td class="text-wrap">{{ lp.title }}</td>
                  <td>{{ lp.publisher.name }}</td>
                  <td>{{ lp.price }}</td>
                  <td>{{ lp.classification.name }}</td>
                  <td>{{ lp.school_level.name }}</td>
                  <td>
                    <button
                      class="btn btn-success"
                      @click="
                        addAsFormNonTeks(
                          lp.title,
                          lp.publisher.name,
                          lp.school_level.name,
                          lp.price,
                          lp.author,
                          lp.descriptions,
                          lp.id,
                          lp.publisher.id,
                          lp.synopsis
                        )
                      "
                    >
                      <i class="fa fa-plus-square" aria-hidden="true"></i>
                      Detail
                    </button>
                  </td>
                  <!-- <td><button class="btn btn-warning" @click="getVal(kl.name,kl.penerbit,kl.jenjang,kl.kelas)">getval</button></td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col">
              <p class="text-muted mt-1 ml-4 pull-left">
                Showing
                {{
                  pusbukPaginationNonText.per_page *
                    pusbukPaginationNonText.current_page -
                    pusbukPaginationNonText.per_page +
                    1
                }}
                to
                {{
                  pusbukPaginationNonText.per_page *
                    pusbukPaginationNonText.current_page
                }}
                of {{ pusbukPaginationNonText.total }} entries
              </p>
            </div>
            <div class="col">
              <pagination
                :data="pusbukPaginationNonText"
                :showDisabled="showDisabled"
                @pagination-change-page="getListPusbuk"
                :align="align"
                :limit="limit"
              ></pagination>
            </div>
          </div>
        </template>
      </div>
    </div>

    <template v-if="isOpenForm">
      <form id="formBuku" class="form">
        <BukuInformasi
          :valName="valName"
          :onEditorChange="onEditorChange"
          :description="descriptionVal"
          :valPenerbit="valPenerbit"
          :valJenjang="valJenjang"
          :valKelas="valKelas"
          :valAuthor="valAuthor"
          :valDesc="valDesc"
          :listPenerbit="listPenerbit"
          :valPenerbitNew="valPenerbitNew"
          :selectedPenerbit="selectedPenerbit"
          :getCategoryVal="getCategoryVal"
          :getSubCategoryVal="getSubCategoryVal"
          :listCategory="listCategory"
          :listSubCategory="listSubCategory"
          :listSub2Category="listSub2Category"
          :typeBook="typeBook"
          :synopsisNonText="synopsisNonText"
        ></BukuInformasi>
        <BukuHarga
          :renderComponent="renderComponent"
          :zone1="valZone1"
          :zone2="valZone2"
          :zone3="valZone3"
          :zone4="valZone4"
          :zone5="valZone5"
          :nonTextPrice="nonTextPrice"
          :hargaNormal="hargaNormal"
          :validationGrosirText="validationGrosirText"
          :grosirAutoCorrectPrice="grosirAutoCorrectPrice"
          :typeBook="typeBook"
        ></BukuHarga>
        <BukuMedia
          :valCoverImage="valCoverImage"
          :renderComponent="renderComponent"
        ></BukuMedia>
        <BukuSpesifikasi></BukuSpesifikasi>
        <button class="btn btn-info" @click="submitAddBuku" type="button">
          Save
        </button>
        <button class="btn btn-secondary" @click="back" type="button">
          Cancel
        </button>
      </form>
    </template>
  </main>
</template>

<script>
// import TableLoader from "/src/components/loader/TableLoader.vue";
// import { getValue } from "vue-currency-input";

import Vue from "vue";
import VueSelect from "vue-select";
import BukuInformasi from "./PartsOfLayout/BukuInformasi";
import BukuHarga from "./PartsOfLayout/BukuHarga";
import BukuMedia from "./PartsOfLayout/BukuMedia";
import BukuSpesifikasi from "./PartsOfLayout/BukuSpesifikasi";
import { mapGetters } from "vuex";
import $ from "jquery";
import publisherJSON from "./btp.json";
import nonTextclassJson from "./nonTextClass.json";
import nonTextLevelclassJson from "./nonTextLevel.json";
import axios from "axios";
export default {
  components: {
    BukuInformasi,
    BukuHarga,
    BukuMedia,
    BukuSpesifikasi,
  },
  data() {
    return {
      isOpen: true,
      isOpenForm: false,
      penerbit: [],
      jenjang: [],
      kelas: [],
      bukuData: {},
      column: {},
      limit: 3,
      limitFilter: 10,
      showDisabled: true,
      align: "right",
      clearable: false,
      valCoverImage: "",
      valName: "",
      valPenerbit: "",
      valZone1: "",
      valZone2: "",
      valZone3: "",
      valZone4: "",
      valZone5: "",
      valAuthor: "",
      valDesc: "",
      valBookId: "",
      valPenerbitId: "",
      descriptionVal: "",
      nonTextPrice: 0,
      synopsisNonText: "",
      renderComponent: true,
      hargaNormal: 0,
      valBrand: 501,
      listPusbuk: [],
      pusbukPagination: {},
      listPusbukNonText: [],
      pusbukPaginationNonText: {},
      listPusbukPenerbitData: publisherJSON,
      listPusbukPenerbit: "",
      seacrh: "",
      nonTextClassData: nonTextclassJson,
      nonTextLevelClassData: nonTextLevelclassJson,
      levelClass: "",
      classModel: "",
      typeBook: "text",
      validationGrosirText: "",
      validationGrosirHasError: "",
      listPenerbit: [],
      selectedPenerbit: "",
      listCategory: [],
      catVal: 0,
      subCatVal: 0,
      listSubCategory: [],
      listSub2Category: [],
    };
  },
  watch: {
    listPusbukPenerbit() {
      this.getListPusbuk(1);
    },
    seacrh() {
      this.getListPusbuk(1);
    },
    typeBook() {
      this.getSubCategory();
      this.getSub2Category();
      this.getBarangCategory();
      this.getListPusbuk(1);
      this.getResult();
      this.isOpenForm = false;
    },
    levelClass() {
      this.getListPusbuk(1);
      this.classModel = "";
    },
    classModel() {
      this.getListPusbuk(1);
    },
    limitFilter() {
      this.getListPusbuk(1);
    },
    statusFilter() {
      this.getResult(1);
    },
    currentSortDir() {
      this.getResult(1);
    },
    valBrand() {
      this.getPenerbit();
    },
    catVal() {
      this.getSubCategory();
    },
    subCatVal() {
      this.getSub2Category();
    },
  },
  created() {
    Vue.component("vue-select", VueSelect);
    this.getResult(1);
  },
  updated() {
    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2Category").addClass("d-none");
    }

    this.typeBook == "text" ? (this.catVal = 4) : (this.catVal = 3);
  },
  async mounted() {
    this.getSearchPusbuk();
    this.getListPusbuk(1);
    this.listPenerbitAndCategory();
    // this.getListPusbuk();
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
  },
  methods: {
    getListPusbuk(page) {
      $("table").addClass("table-loading");
      var formdata = new FormData();
      var myHeaders = new Headers();

      formdata.append(
        "url",
        `catalog/books/types/${this.typeBook}?page=${page}&limit=${this.limitFilter}&search=${this.seacrh}&level=${this.levelClass}&class=${this.classModel}`
      );
      // formdata.append("method", "GET");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      };
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/config/aggregationBooks/`,
        requestOptions
      )
        .then((res) => {
          $("table").removeClass("table-loading");
          return res.json();
        })
        .then((data) => {
          if (this.typeBook == "text") {
            this.listPusbuk = data.data;
            this.pusbukPagination = data.pagination;
            // this.listPusbukPenerbit = data.data;

            this.pusbukPagination = {
              current_page: this.pusbukPagination.page,
              data: this.listPusbuk,
              from: 1,
              last_page: this.pusbukPagination.total_pages,
              next_page_url: this.pusbukPagination.page + 1,
              per_page: this.pusbukPagination.per_page,
              prev_page_url: null,
              to: 5,
              total: this.pusbukPagination.total_items,
            };
          } else {
            this.listPusbukNonText = data.data;
            this.pusbukPaginationNonText = data.pagination;

            this.pusbukPaginationNonText = {
              current_page: this.pusbukPaginationNonText.page,
              data: this.listPusbukNonText,
              from: 1,
              last_page: this.pusbukPaginationNonText.total_pages,
              next_page_url: this.pusbukPaginationNonText.page + 1,
              per_page: this.pusbukPaginationNonText.per_page,
              prev_page_url: null,
              to: 5,
              total: this.pusbukPaginationNonText.total_items,
            };
          }
        });

      // var e = document.getElementById("forPenerbitVal");
      // let strPen = e.value;
      // this.valBrand = strPen;
    },
    addAsForm(
      val1,
      imageVal,
      val2,
      val3,
      val4,
      valZ1,
      valZ2,
      valZ3,
      valZ4,
      valZ5,
      valAuthorName,
      valDescription,
      valBID,
      valPID
    ) {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Lanjut menambahkan produk ini? </span>`,
          // text: "",
          icon: "question",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.valName = val1;
            this.valCoverImage = imageVal;
            this.valPenerbit = val2;
            this.valJenjang = val3;
            this.valKelas = val4;
            this.valZone1 = valZ1;
            this.valZone2 = valZ2;
            this.valZone3 = valZ3;
            this.valZone4 = valZ4;
            this.valZone5 = valZ5;
            this.valAuthor = valAuthorName;
            this.valDesc = valDescription;
            this.valBookId = valBID;
            this.valPenerbitId = valPID;
            this.isOpenForm = true;

            this.renderComponent = false;
            this.$nextTick(() => {
              // Add the component back in
              this.renderComponent = true;
            });
            this.$swal.fire({
              title: "Mohon Tunggu",
              text: "Sedang memproses...",
              showConfirmButton: false,
            });
            setTimeout(() => {
              this.$swal.close();
            }, 700);
            setTimeout(() => {
              //scroll to first card
              document
                .getElementById("forScrollBook")
                .scrollIntoView({ behavior: "smooth" });
            }, 1000);

            // this.$swal.fire('belum','belum','warning')
          }
        });
    },
    addAsFormNonTeks(
      title,
      publisher,
      school_level,
      price,
      author,
      descriptions,
      id,
      pid,
      synopsis
    ) {
      // console.log('1',title,  '2',publisher, '3',school_level, '4',price, '5',author, '6',descriptions, '7',id, '8',pid)
      // console.log(price)
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Lanjut menambahkan produk ini? </span>`,
          // text: "",
          icon: "question",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.valName = title;
            this.valPenerbit = publisher;
            this.valJenjang = school_level;
            this.nonTextPrice = price;
            this.valAuthor = author;
            this.valDesc = descriptions;
            this.valBookId = id;
            this.valPenerbitId = pid;
            this.synopsisNonText = synopsis;
            this.isOpenForm = true;

            this.renderComponent = false;
            this.$nextTick(() => {
              // Add the component back in
              this.renderComponent = true;
            });

            this.$swal.fire({
              title: "Mohon Tunggu",
              text: "Sedang memproses...",
              showConfirmButton: false,
            });

            setTimeout(() => {
              this.$swal.close();
            }, 700);
            setTimeout(() => {
              //scroll to first card
              document
                .getElementById("forScrollBook")
                .scrollIntoView({ behavior: "smooth" });
            }, 1000);

            // this.$swal.fire('belum','belum','warning')
          }
        });
    },
    submitAddBuku() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=cka0bd7kh7gs6cvt6tmvb7s93vtn3rav");

      // let photoCover = document.getElementById("coverUpload").files[0].name;
      let defaultPhotoCover = new File([null], null, {
        type: "image/jpeg",
      });

      var data = [];
      var res = document.getElementsByClassName("form-control");
      var arr = Array.from(res);
      for (let i = 0; i < arr.length; i++) {
        data += arr[i].classList;
      }
      if (data.includes("is-invalid")) {
        this.validationGrosirHasError = true;
      } else {
        this.validationGrosirHasError = false;
      }

      try {
        document.getElementById("coverUpload").files[0].name;
      } catch (error) {
        this.$swal
          .fire(
            `<span style='font-size:17px'>Perhatian</span>`,
            "Foto utama tidak boleh kosong!",
            "info"
          )
          .then((res) => {
            if (res.isConfirmed) {
              setTimeout(() => {
                document.getElementById("layoutMedia").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          });
      }

      if ($("#bookPriceZone1").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 1 tidak boleh melebihi Harga Maksimal zona 1",
          "warning"
        );
        // alert("cek harga 1");
      } else if ($("#bookPriceZone2").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 2 tidak boleh melebihi Harga Maksimal zona 2",
          "warning"
        );
      } else if ($("#bookPriceZone3").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 3 tidak boleh melebihi Harga Maksimal zona 3",
          "warning"
        );
      } else if ($("#bookPriceZone4").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 4 tidak boleh melebihi Harga Maksimal zona 4",
          "warning"
        );
      } else if ($("#bookPriceZone5").hasClass("is-invalid")) {
        this.$swal.fire(
          "Perhatian",
          "Harga Zona 5 tidak boleh melebihi Harga Maksimal zona 5",
          "warning"
        );
      } else if (
        $("#bookMinWholesaleZone1Part1")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Pembelian minimum tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#bookMinWholesaleZone1Part2")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Pembelian minimum tidak boleh kurang dari 0",
          "warning"
        );
      } else if ($("#bookManufacturer").hasClass("is-invalid")) {
        this.$swal
          .fire(
            "Perhatian",
            "Pilih Penerbit terlebih dahulu yang sesuai dengan table diatas",
            "warning"
          )
          .then((res) => {
            if (res.isConfirmed) {
              setTimeout(() => {
                document.getElementById("forScrollBook").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          });
      } else if (
        $("#bookStock")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Stok tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        ($("#bookWeigth")
          .val()
          .includes("-") &&
          $("#bookWeigth").hasClass("is-invalid")) ||
        ($("#bookWeigth").val() === 0 &&
          $("#bookWeigth").hasClass("is-invalid"))
      ) {
        // this.validationWeight = "Berat tidak boleh kurang dari 0";
        this.$swal.fire(
          "Perhatian",
          "Berat tidak boleh kurang dari 0",
          "warning"
        );
      } else if (
        $("#bookLength")
          .val()
          .includes("-") ||
        $("#bookWidth")
          .val()
          .includes("-") ||
        $("#bookHeight")
          .val()
          .includes("-")
      ) {
        this.$swal.fire(
          "Perhatian",
          "Panjang, Lebar, Tinggu tidak boleh kurang dari 0",
          "warning"
        );
      } else if (this.validationGrosirHasError === true) {
        this.$swal.fire("Perhatian", `${this.validationGrosirText}`, "warning");
      } else {
        // let photoName1 = document.getElementById("photoUpload1").files[0].name;
        let defaultPhoto1 = new File([null], null, {
          type: "image/jpeg",
        });

        var formdata = new FormData();
        formdata.append("produk", $("#bookName").val());
        formdata.append("produk_tag", $("#bookTag").val());
        formdata.append("layout", "1");
        formdata.append("jenis_pkp", this.user.type);
        formdata.append("model", $("#bookCode").val());
        formdata.append("seo", $("#bookSeo").val());
        formdata.append("l_merk", this.selectedPenerbit);
        formdata.append(
          "category_id",
          this.listSub2Category.length === 0
            ? $("#nonBookSubCategory").val()
            : $("#nonBookSub2Category").val()
        );
        formdata.append(
          "KategoriSub",
          this.listSub2Category.length === 0
            ? $("#nonBookSubCategory").val()
            : $("#nonBookSub2Category").val()
        );
        formdata.append("description", this.descriptionVal);
        formdata.append("harga", 0);
        formdata.append("unit_type", "pcs");
        formdata.append("harga_nego", 0);
        formdata.append("ppn", $("#bookPpn").val());
        formdata.append(
          "grosir_pricezone1",
          JSON.stringify([
            {
              min: $("#bookMinWholesaleZone1Part1").val(),
              price: $("#bookWholesalePriceZone1Part1")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone1Part2").val(),
              price: $("#bookWholesalePriceZone1Part2")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone1Part3").val(),
              price: $("#bookWholesalePriceZone1Part3")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone1Part4").val(),
              price: $("#bookWholesalePriceZone1Part4")
                .val()
                .replace(/\./g, ""),
            },
          ])
        );
        formdata.append(
          "grosir_pricezone2",
          JSON.stringify([
            {
              min: $("#bookMinWholesaleZone2Part1").val(),
              price: $("#bookWholesalePriceZone2Part1")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone2Part2").val(),
              price: $("#bookWholesalePriceZone2Part2")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone2Part3").val(),
              price: $("#bookWholesalePriceZone2Part3")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone2Part4").val(),
              price: $("#bookWholesalePriceZone2Part4")
                .val()
                .replace(/\./g, ""),
            },
          ])
        );
        formdata.append(
          "grosir_pricezone3",
          JSON.stringify([
            {
              min: $("#bookMinWholesaleZone3Part1").val(),
              price: $("#bookWholesalePriceZone3Part1")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone3Part2").val(),
              price: $("#bookWholesalePriceZone3Part2")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone3Part3").val(),
              price: $("#bookWholesalePriceZone3Part3")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone3Part4").val(),
              price: $("#bookWholesalePriceZone3Part4")
                .val()
                .replace(/\./g, ""),
            },
          ])
        );
        formdata.append(
          "grosir_pricezone4",
          JSON.stringify([
            {
              min: $("#bookMinWholesaleZone4Part1").val(),
              price: $("#bookWholesalePriceZone4Part1")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone4Part2").val(),
              price: $("#bookWholesalePriceZone4Part2")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone4Part3").val(),
              price: $("#bookWholesalePriceZone4Part3")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone4Part4").val(),
              price: $("#bookWholesalePriceZone4Part4")
                .val()
                .replace(/\./g, ""),
            },
          ])
        );
        formdata.append(
          "grosir_pricezone5",
          JSON.stringify([
            {
              min: $("#bookMinWholesaleZone5Part1").val(),
              price: $("#bookWholesalePriceZone5Part1")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone5Part2").val(),
              price: $("#bookWholesalePriceZone5Part2")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone5Part3").val(),
              price: $("#bookWholesalePriceZone5Part3")
                .val()
                .replace(/\./g, ""),
            },
            {
              min: $("#bookMinWholesaleZone5Part4").val(),
              price: $("#bookWholesalePriceZone5Part4")
                .val()
                .replace(/\./g, ""),
            },
          ])
        );
        formdata.append("produksi", "");
        formdata.append("jml_halaman", ""); //belum
        formdata.append("barang_produsen", $("#bookProducer").val());
        formdata.append("kondisi", "Baru");
        formdata.append(
          "s_gudang",
          $("#bookStock")
            .val()
            .replace(/\./g, "")
        );
        formdata.append("garansi", "");
        formdata.append("berat", $("#bookWeigth").val());
        formdata.append("panjang", $("#bookLength").val());
        formdata.append("lebar", $("#bookWidth").val());
        formdata.append("tinggi", $("#bookHeight").val());
        formdata.append("d_status", 0);
        formdata.append("book_id", this.valBookId);
        formdata.append("item_type", 1);

        formdata.append("mall_id", this.user.id);
        formdata.append(
          "harga1",
          this.typeBook == "text"
            ? $("#bookPriceZone1")
                .val()
                .replace(/\./g, "")
            : this.nonTextPrice
        );
        formdata.append(
          "harga2",
          this.typeBook == "text"
            ? $("#bookPriceZone2")
                .val()
                .replace(/\./g, "")
            : this.nonTextPrice
        );
        formdata.append(
          "harga3",
          this.typeBook == "text"
            ? $("#bookPriceZone3")
                .val()
                .replace(/\./g, "")
            : this.nonTextPrice
        );
        formdata.append(
          "harga4",
          this.typeBook == "text"
            ? $("#bookPriceZone4")
                .val()
                .replace(/\./g, "")
            : this.nonTextPrice
        );
        formdata.append(
          "harga5",
          this.typeBook == "text"
            ? $("#bookPriceZone5")
                .val()
                .replace(/\./g, "")
            : this.nonTextPrice
        );

        formdata.append(
          "filefotoutama",
          document.getElementById("coverUpload").files[0],
          document.getElementById("coverUpload").files.length === 0
            ? defaultPhotoCover.name
            : document.getElementById("coverUpload").files[0].name
        );

        formdata.append(
          "filefoto0",
          document.getElementById("photoUpload1").files.length === 0
            ? defaultPhoto1
            : document.getElementById("photoUpload1").files[0],
          document.getElementById("photoUpload1").files.length === 0
            ? defaultPhoto1.name
            : document.getElementById("photoUpload1").files[0].name
        );

        // for (var pair of formdata.entries()) {
        //   console.log(pair[0] + ", " + pair[1]);
        // }

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        this.$swal
          .fire({
            title: "Anda yakin?",
            text: "Anda yakin ingin menambah buku ini ke dalam toko anda?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              let timerInterval = timerInterval;
              this.$swal.fire({
                title: "<span style='font-size:17px'>Sedang diproses</span>",
                html: "Mohon Tunggu...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                width: 350,
                didOpen: () => {
                  this.$swal.showLoading();
                  timerInterval = setInterval(() => {
                    const content = this.$swal.getContent();
                    if (content) {
                      const b = content.querySelector("b");
                      if (b) {
                        b.textContent = this.$swal.getTimerLeft();
                      }
                    }
                  }, 100);
                },
              });
              fetch(
                "https://siplah.eurekabookhouse.co.id/staging/backendseller/katalog/produk_api/addproduk",
                requestOptions
              )
                .then((response) => response.json())
                .then((data) => {
                  this.$swal.close();
                  this.$router.push({
                    path: "/product",
                  });
                  this.$swal.fire("Sukses!", data.title, "success");
                })
                .catch((error) => console.log("error", error));
            }
          });
      }
    },
    valPenerbitNew() {
      this.selectedPenerbit = Number($("#bookManufacturer").val());
      if (this.isOpenForm) {
        this.getSubCategory();
        this.getSub2Category();
        this.getBarangCategory();
      }
    },
    grosirAutoCorrectPrice(numberZone, maxNumberZone) {
      let zoneDef = $(`#${numberZone}`).val();
      let maxZone = $(`#${maxNumberZone}`).val();
      let splitedZone = Number(zoneDef.split(".").join(""));
      let splitedMaxZone = Number(maxZone.split(".").join(""));

      if (splitedZone > splitedMaxZone) {
        $(`.invalid${numberZone}`).text(
          `Harga tidak boleh melewati Rp${maxZone}`
        );
        this.validationGrosirText = `Harga Grosir tidak boleh melewati Rp${maxZone}`;
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val(splitedMaxZone)
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})</span>`,
        //   icon:'warning'
        // }).then(() => {
        //   $(`#${numberZone}`).val(maxZone)
        // })
      } else if (zoneDef.includes("-")) {
        $(`#${numberZone}`).val(0);
      } else if (
        splitedZone < splitedMaxZone &&
        this.validationGrosirHasError === false
      ) {
        this.validationGrosirText = "";
      } else {
        $(`#${numberZone}`).removeClass("is-invalid");
      }

      if (splitedZone.toString() < 0) {
        $(`.invalid${numberZone}`).text(`Harga tidak boleh kosong`);
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val()
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh kosong</span>`,
        //   icon:'warning'
        // })
      }
    },
    listPenerbitAndCategory() {
      fetch(
        "https://siplah.eurekabookhouse.co.id/staging/backendseller/katalog/produk_api/detailproduk/"
      )
        .then((response) => response.json())
        .then((data) => {
          this.listPenerbit = data.listpenerbit;
          // this.listCategory = data.listcat;
        });
    },
    //category
    filterCatBook(listCat) {
      let isTextBook = this.typeBook;
      return isTextBook == "text" ? listCat.id == 22 : listCat.id == 23;
    },
    getBarangCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          // this.listCategory = data.data.data[0].submenu.menu;
          this.listCategory = catList.filter(this.filterCatBook);
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
        });
    },
    getCategoryVal() {
      let isTextBook = this.typeBook;
      $("#loadingCategory1").removeClass("d-none");
      $("#nonBookSubCategory").addClass("d-none");
      var index = $("#nonBookCategory").prop("selectedIndex");
      //index di + 3 dikarenakan yg di ambil hanya kategori buku teks dan buku non teks
      this.catVal = isTextBook == "text" ? index + 4 : index + 3;
      this.subCatVal = 0;
      $("#nonBookSub2Category").addClass("d-none");
    },
    getSubCategory() {
      this.subCatVal = 0;
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catVal].submenu;
          $("#loadingCategory1").addClass("d-none");
          $("#nonBookSubCategory").removeClass("d-none");
        });
    },
    getSubCategoryVal() {
      $("#loadingCategory2").removeClass("d-none");
      $("#nonBookSub2Category").addClass("d-none");
      var index = $("#nonBookSubCategory").prop("selectedIndex");
      this.subCatVal = index;
    },
    getSub2Category() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSub2Category =
            data.data.data[0].submenu.menu[this.catVal].submenu[
              this.subCatVal
            ].submenu;
          $("#loadingCategory2").addClass("d-none");
          $("#nonBookSub2Category").removeClass("d-none");
        });
    },
    //end category
    getSearchPusbuk() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=34v04orna38v7nqmeatag7tvs5vvitgm");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        "https://siplah.eurekabookhouse.co.id/staging/backendseller/katalog/produk_api/searchpusbuk/",
        requestOptions
      )
        .then((response) => response.json())
        .then(
          (result) => (
            (this.jenisKategori = result.jenis_kategori),
            (this.jenjang = result.jenjang_default),
            (this.kelas = result.kelas)
          )
        );
      // .then(() => {
      //   console.log(this.kelas);
      // });
      // this.jenisKategori;
    },
    getPenerbitVal() {
      var formdata = new FormData();
      var myHeaders = new Headers();

      formdata.append("url", "catalog/books/types/text");
      formdata.append("method", "GET");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      };
      fetch(`https://siplah.eurekabookhouse.co.id/agregation/`, requestOptions)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.listPusbuk = data.data;
        });

      // var e = document.getElementById("forPenerbitVal");
      // let strPen = e.value;
      // this.valBrand = strPen;
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.descriptionVal = html;
    },
    camelize(text) {
      text = text.replace(/[-_\s.]+(.)?/g, (_, c) =>
        c ? c.toUpperCase() : ""
      );
      return text.substr(0, 1).toLowerCase() + text.substr(1);
    },
    getResult() {
      if (this.typeBook == "text") {
        this.column = [
          {
            value: "",
            name: "No",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Name",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Penerbit",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Jenjang",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Kelas",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Zone1",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Zone2",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Zone3",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Zone4",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Zone5",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Aksi",
            isOrder: "",
            order: "",
          },
        ];
      } else {
        this.column = [
          {
            value: "",
            name: "No",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Name",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Penerbit",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Harga",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Klasifikasi",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Kelas",
            isOrder: "",
            order: "",
          },
          {
            value: "",
            name: "Aksi",
            isOrder: "",
            order: "",
          },
        ];
      }
    },

    back() {
      this.$swal
        .fire({
          title: `<span style='font-size:17px'>Anda yakin ingin membatal</span>`,
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: "/product" });
          }
        });
    },
    // getVal(){

    // }
  },
};
</script>

<style>
.select-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png)
    no-repeat right #ddd;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #818181;
  color: #464545;
  padding: 0px 0px 0px 30px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

/* For IE <= 11 */
.select-filter::-ms-expand {
  display: none;
}

select option {
  /* margin: 40px; */
  background-color: #fff;
  color: #fff;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); */
}

.select-filter-icon {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 30px;
  height: 36px;
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.select-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.input-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 0.3px solid #818181;
  /* color: #464545; */
  padding: 0px 0px 0px 40px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

.input-filter::-ms-expand {
  display: none;
}

.input-filter-icon {
  position: absolute;
  top: 5px;
  left: 20px;
  width: 80%;
  /* height: 36px; */
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.input-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter:hover ~ .select-filter-icon svg.icon,
.select-filter:focus ~ .select-filter-icon svg.icon {
  fill: #464545;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #12476d;
  border-color: #12476d;
}

.page-link {
  color: #5e5f5f;
}

.page-link:hover {
  color: #12476d;
}
</style>
